import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadDocumentIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 11.5L4 6C4 3.79086 5.79086 2 8 2H16C18.2091 2 20 3.79086 20 6V17C20 19.2091 18.2091 21 16 21V21",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 6.5H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 9.5H9",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.81079 22.1213L6.81079 14.6213L8.31079 14.6213L8.31079 22.1213L6.81079 22.1213Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.0607 18.6213L7.56068 15.1213L4.06068 18.6213L3.00002 17.5607L6.50002 14.0607C7.0858 13.4749 8.03555 13.4749 8.62134 14.0607L12.1213 17.5607L11.0607 18.6213Z",
			fill: "white"
		})
	]
});
export default SvgUploadDocumentIcon;
